import React from "react";
import { ContactPreview } from "./ContactPreviewPanel";
import { useContacts } from "utilities/hookutils";

interface PreviewPanelContactListProps {
  contacts: server.dto.ContactSmallV2[]
}

export const PreviewPanelContactList = (props: PreviewPanelContactListProps) => {
  const contacts = useContacts(props.contacts);

  return <>
    {contacts.map((contact, index) => <React.Fragment key={contact.contactId}>
      <ContactPreview
        contactId={contact.contactId}
        trigger={<a>{contact.name.fullName}</a>}
        fallbackIfNoPermission={<>{contact.name.fullName}</>}
      />
      {index !== contacts.length - 1 && <>, </>}
    </React.Fragment>)}
  </>
}